<script setup lang="ts">
defineProps<{
  visible: boolean
  address: string
  tipStyle: Record<string, string>
}>()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="schedule-slot-occupied-tip"
      role="tooltip"
      :style="tipStyle"
    >
      <span class="schedule-slot-occupied-tip-text">{{ address }}</span>
    </div>
  </Teleport>
</template>

<style scoped>
.schedule-slot-occupied-tip {
  position: fixed;
  z-index: 12750;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 263px;
  min-width: 263px;
  max-width: 263px;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  padding: 4px 12px;
  background: #fef39c;
  border-radius: 0;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
  pointer-events: none;
  overflow: hidden;
}

.schedule-slot-occupied-tip-text {
  display: block;
  box-sizing: border-box;
  width: 239px;
  min-width: 239px;
  max-width: 239px;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  margin: 0;
  padding: 0;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0;
  color: #484848;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
